import { useEffect } from 'react';
import { useGameStore } from '@/store/game-store';
import PokerTable from '@/components/PokerTable';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Play } from 'lucide-react';

interface GamePageProps {
  onNavigate: (page: 'home' | 'lobby') => void;
}

export default function GamePage({ onNavigate }: GamePageProps) {
  const { gameState, resetGame, startNewHand } = useGameStore();

  // 如果没有游戏状态，返回大厅
  useEffect(() => {
    if (!gameState) {
      onNavigate('lobby');
    }
  }, [gameState, onNavigate]);

  if (!gameState) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <p className="text-white">加载中...</p>
      </div>
    );
  }

  const handleLeaveGame = () => {
    if (confirm('确定要离开游戏吗？当前游戏进度将丢失。')) {
      resetGame();
      onNavigate('lobby');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-green-900 to-slate-900">
      {/* 顶部导航 */}
      <nav className="p-4 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Button
            variant="ghost"
            size="icon"
            onClick={handleLeaveGame}
            className="text-white hover:bg-white/10"
          >
            <ArrowLeft className="w-6 h-6" />
          </Button>
          <div>
            <h1 className="text-lg font-bold text-white">
              {gameState.mode === 'casual' ? '休闲场' :
               gameState.mode === 'tournament_low' ? '锦标赛（低）' :
               gameState.mode === 'tournament_mid' ? '锦标赛（中）' :
               gameState.mode === 'tournament_high' ? '锦标赛（高）' : '急速赛'}
            </h1>
            <p className="text-white/60 text-sm">手牌 #{gameState.handNumber}</p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          {gameState.phase === 'settlement' && (
            <Button
              onClick={startNewHand}
              className="bg-amber-600 hover:bg-amber-500"
            >
              <Play className="w-4 h-4 mr-2" />
              下一手
            </Button>
          )}
        </div>
      </nav>

      {/* 游戏桌 */}
      <main className="container mx-auto px-4 py-4 h-[calc(100vh-80px)]">
        <PokerTable gameState={gameState} />
      </main>
    </div>
  );
}
